import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header/Header'
import Sidebar from '../../../Components/Sidebar/Sidebar'
import GardenMaintainanceCardManage from './GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceCardManage'
import STPMasterCardManage from './STPDashboardComponent/STPMasterCard/STPMasterCardManage'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../Helper/Data'
import STPPreventiveCardManage from './STPDashboardComponent/STPPreventiveWorkCard/STPPreventiveCardManage'
import { useAuthState } from '../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../../Helper/Loading'
import CommonDashboardWardNameDDL from './CommonDashboardWardNameDDL'
import { STPDashboardMainCountDataAPI } from '../../../Redux/STPDashboardSlice/STPCount/STPCountSlice'
import { STPGroupButton } from './STPDashboardComponent/STPGroupButton/STPGroupButton'
import { STPOfficialVisitGrid } from './STPDashboardComponent/STPGroupButton/STPOfficialVisitGrid'


export const STPDashboard = () => {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select Ward",
    })
    const [Countdata, setCountdata] = useState({})
    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ActiveBtn, SetActiveBtn] = useState(RoleID == 2 ? "STP Official Visit" : '')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }
        if (Ward.ID != 0 && Month.ID != 0 && year.ID != 0) {
            dispatch(STPDashboardMainCountDataAPI({ data }))
        }
    }, [Ward.ID, Month.ID, year.ID])

    const { STPDashboardCountData, isLoading } = useSelector(state => state.STPDashboardMainCountData)

    const handleGetCount = (data) => {
        // console.log("data", data)
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }




    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="main-content side_shrink position-relative border-radius-lg "></div> */}
            <div>
                <Header
                    DashboardHeading="Water Supply Maintenance"
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                    Name="STP"
                />
                {/* <Sidebar active="dashboard" /> */}
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content1 content">

                        {/* <div id="page-content-wrapper"> */}
                        {/* <div className="pcoded-main-container main-row">
                        <div className="pcoded-content "> */}
                        {/* <!-- [ breadcrumb ] start --> */}
                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                        />
                        {/* <!-- [ Main Content ] start -->
            <!--  --> */}

                        {/* <div className="mb-4 m-1 py-2 px-3 master_border" style={{ borderRadius: "15px"}}>
                            <GardenMaintainanceCardManage />
                        </div> */}
                        {
                            (M_ProjectTypeID == 0 && RoleID == 2) &&
                            <div className=" m-1 p-0 pt-2">
                                <STPGroupButton
                                    ActiveBtn={ActiveBtn}
                                    SetActiveBtn={SetActiveBtn}
                                />
                            </div>
                        }

                        {
                            ActiveBtn == "STP Official Visit" ?
                                <div className="m-1 p-0  mt-3">
                                    <STPOfficialVisitGrid
                                        FinancialYear={FinancialYear?.ID}
                                        Month={Month?.ID}
                                        M_WardID={WardValue}
                                        AssetID='0'
                                    />
                                </div>
                                :
                                <>
                                    <div className="m-1 p-2 pb-3 master_border">
                                        {/*  */}
                                        <STPMasterCardManage
                                            Countdata={Countdata}
                                            YearValue={YearValue}
                                            YearLabel={YearLabel}
                                            MonthValue={MonthValue}
                                            MonthLabel={MonthLabel}
                                            WardValue={WardValue}
                                            WardLabel={WardLabel}
                                            ProjectTypeId={ProjectTypeId}
                                            DashboardName={DashboardName}
                                        />
                                    </div>

                                    <div className="row mt-4 m-1 py-2 pb-0 master_border">
                                        <STPPreventiveCardManage
                                            Countdata={Countdata}
                                            YearValue={YearValue}
                                            YearLabel={YearLabel}
                                            MonthValue={MonthValue}
                                            MonthLabel={MonthLabel}
                                            WardValue={WardValue}
                                            WardLabel={WardLabel}
                                            ProjectTypeId={ProjectTypeId}
                                            DashboardName={DashboardName}
                                        />



                                        {/* <div className='row mt-5'>
                                <div className="col-12 col-lg-6 mb-2 ">
                                    <STPPreventiveCard
                                        title="House Keeping"
                                        cardName='py-2 wwork_img cursor'
                                        imgPath='./assets/img/house-cleaning.png'
                                        count='100'
                                    // navLink='/preventivehousekeeping'
                                    // PreventiveWorkNavigate={PreventiveWorkNavigate}
                                    />

                                </div>

                                <div className="col-12 col-lg-6 mb-2">
                                    <STPPreventiveCard
                                        title="House Keeping"
                                        cardName='py-2 wwork_img cursor'
                                        imgPath='./assets/img/house-cleaning.png'
                                        count='100'
                                    // navLink='/preventivehousekeeping'
                                    // PreventiveWorkNavigate={PreventiveWorkNavigate}
                                    />

                                </div>
                            </div> */}
                                        {/*  */}

                                    </div>
                                </>
                        }
                        {/* <div className="row mt-4 m-1 py-2 pb-2 master_border d-flex align-items-center">
                            <div className="col-12">
                                <h5 className="ps-2">Preventive Work</h5>
                            </div>
                        </div>
                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                            <div className="col-12 mb-3">
                                <h5 className="ps-2">Preventive Maintainance Work</h5>
                            </div>

                        </div>
                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                            <div className="col-12">
                                <h5 className="ps-2 py-2 ">Assigned Maintainance Work</h5>
                            </div>
                        </div> */}
                    </div>
                    {/* <!-- [ Main Content ] end --> */}
                </div>
            </div>
        </>


    )
}
